import React, { useEffect, useState } from 'react'
import { Typography, Paper, Box, Grid, Card, CardContent, TextField, InputAdornment, IconButton, Select, MenuItem, FormControl, InputLabel, Button, Drawer, List, ListItem, ListItemText, ListItemIcon, Checkbox, Divider, Chip, Tabs, Tab, Tooltip } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import ViewColumnIcon from '@mui/icons-material/ViewColumn'
import ChatIcon from '@mui/icons-material/Chat'
import CallIcon from '@mui/icons-material/Call'
import InfoIcon from '@mui/icons-material/Info'
import useFullPageLoader from '../../hooks/useFullPageLoader'
import { toastMessage } from '../../utils/toastMessage'
import { fetchConsultantInsightsApi } from '../../services/insightManagement'
import NotFound from '../../components/not-found/NotFound'
import { formatToTwoDecimalPoints } from '../../utils/dateFormat'
import { Link } from 'react-router-dom'
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Pagination from 'react-js-pagination'
import moment from 'moment'
import { fatchCategoryApi } from '../../services/categoryManagement'

const ConsultantInsight = () => {
  const [insightsData, setInsightsData] = useState({})
  const [consultationList, setConsultationList] = useState([])
  const [total, setTotal] = useState(0)
  const [activePage, setActivePage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchQuery, setSearchQuery] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [loader, showLoader, hideLoader] = useFullPageLoader()

  // Filter states
  const [timeRange, setTimeRange] = useState('')
  const [consultantType, setConsultantType] = useState('')
  const [problemType, setProblemType] = useState('')
  const [consultantGender, setConsultantGender] = useState('')
  const [userGender, setUserGender] = useState('')
  const [masterData, setMasterData] = useState([])
  const [consultantSkillOption, setConsultantSkillOption] = useState([])
  const [otherSkillOption, setOtherSkillOption] = useState([])
  const [expertiseOption, setExpertiseOption] = useState([])
  const [languageOption, setLanguageOption] = useState([])
  const [consultantSkillLoader, setConsultantSkillLoader] = useState(false)
  
  // Consultant Insights Presentation states
  const [insightType, setInsightType] = useState('all') // 'all', 'custom', 'single'
  const [selectedConsultants, setSelectedConsultants] = useState([])
  const [singleConsultant, setSingleConsultant] = useState('')
  const [consultantList, setConsultantList] = useState([])
  
  // Table row selection states
  const [selectedTableRows, setSelectedTableRows] = useState([])
  const [selectAllRows, setSelectAllRows] = useState(false)
  
  // fetch consultant skill
  const fetchMasterData = async () => {
    try {
      const { data } = await fatchCategoryApi();
      if (data.code === 200) {
        const updatedConsultantSkill =
          data?.result?.skillList &&
          data?.result?.skillList.length > 0 &&
          data?.result?.skillList.map(({ _id, title }) => ({
            value: title,
            label: title,
          }));

        setConsultantSkillOption(updatedConsultantSkill);
        setOtherSkillOption(updatedConsultantSkill);
 

        const expertise =
          data?.result?.categoryList &&
          data?.result?.categoryList.length > 0 &&
          data.result.categoryList.map(({ _id, title }) => ({
            value: title,
            label: title,
          }));
        setExpertiseOption(expertise);

        const language =
          data?.result?.languageList &&
          data?.result?.languageList.length > 0 &&
          data.result.languageList.map(({ _id, title }) => ({
            value: title,
            label: title,
          }));

        console.log(language, "language");
        setLanguageOption(language);
      } else {
        setConsultantSkillOption([]);
        setOtherSkillOption([]);
        setExpertiseOption([]);
        setLanguageOption([]);

        toastMessage(data.message, "error", "categoryList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setConsultantSkillLoader(false);
    }
  };

  useEffect(() => {
        fetchMasterData();
  }, []);

  // Fetch consultant list for selection
  const fetchConsultantList = async () => {
    try {
      // This would be replaced with actual API call to get consultant list
      // For now, we'll use a mock structure
      const mockConsultants = [
        { _id: '1', name: 'John Doe', type: 'Astrology' },
        { _id: '2', name: 'Jane Smith', type: 'Numerology' },
        { _id: '3', name: 'Mike Johnson', type: 'Palmistry' },
        // Add more mock data as needed
      ]
      setConsultantList(mockConsultants)
    } catch (error) {
      console.error('Error fetching consultant list:', error)
    }
  }

  useEffect(() => {
    fetchConsultantList()
  }, [])
  
  // Tab state for chat/call separation
  const [activeTab, setActiveTab] = useState(0) // 0: Combined, 1: Chat, 2: Call
  
  // Column selection states
  const [columnSelectorOpen, setColumnSelectorOpen] = useState(false)
  const [visibleColumns, setVisibleColumns] = useState({
    // Consultant Information
    consultantName: true,
    consultantType: true,
    
    // Combined Attempts & Completion Metrics
    totalAttemptChatCall: true,
    totalFailedChatCall: true,
    totalCompletedChatCall: true,
    
    // Chat Attempts & Completion Metrics
    totalAttemptChat: true,
    totalFailedChat: true,
    totalCompletedChat: true,
    
    // Call Attempts & Completion Metrics
    totalAttemptCall: true,
    totalFailedCall: true,
    totalCompletedCall: true,
    
    // Chat Metrics - Detailed
    totalFreeChat: true,
    totalPaidChat: true,
    totalFirstTimeChat: true,
    totalRepeatChat: true,
    
    // Call Metrics - Detailed
    totalFreeCall: true,
    totalPaidCall: true,
    totalFirstTimeCall: true,
    totalRepeatCall: true,
    
          // Completion Rates
      completionRatePercentage: true,
      completionRateNumber: true,
    
    // Chat Percentage Analysis
    freeChatPercentage: true,
    paidChatPercentage: true,
    firstTimePaidChatPercentage: true,
    repeatPaidChatPercentage: true,
    
    // Call Percentage Analysis
    freeCallPercentage: true,
    paidCallPercentage: true,
    firstTimePaidCallPercentage: true,
    repeatPaidCallPercentage: true,
    
    // General Time Metrics (Chat + Call combined)
    totalChatCallTime: true,
    averageChatCallTime: true,
    
    // Chat Time Metrics
    totalFreeChatTime: true,
    averageFreeChatTime: true,
    totalPaidChatTime: true,
    averagePaidChatTime: true,
    totalFirstTimePaidChatTime: true,
    averageFirstTimePaidChatTime: true,
    totalRepeatChatTime: true,
    averageRepeatChatTime: true,
    
    // Call Time Metrics
    totalFreeCallTime: true,
    averageFreeCallTime: true,
    totalPaidCallTime: true,
    averagePaidCallTime: true,
    totalFirstTimePaidCallTime: true,
    averageFirstTimePaidCallTime: true,
    totalRepeatCallTime: true,
    averageRepeatCallTime: true,
    
    // General Revenue Metrics (Chat + Call combined)
    totalChatCallRevenue: true,
    averageChatCallRevenue: true,
    
    // Chat Revenue Metrics
    totalPaidChatRevenue: true,
    averagePaidChatRevenue: true,
    totalFirstTimePaidChatRevenue: true,
    averageFirstTimePaidChatRevenue: true,
    totalRepeatPaidChatRevenue: true,
    averageRepeatPaidChatRevenue: true,
    
    // Call Revenue Metrics
    totalPaidCallRevenue: true,
    averagePaidCallRevenue: true,
    totalFirstTimePaidCallRevenue: true,
    averageFirstTimePaidCallRevenue: true,
    totalRepeatPaidCallRevenue: true,
    averageRepeatPaidCallRevenue: true,
    
    // Overall Performance Metrics
  })

  // Column information for tooltips - matching user insight structure
  const columnInfo = {
    consultantName: 'Name of the consultant',
    consultantType: 'Type of consultation service provided by the consultant',
    totalAttemptChatCall: 'Total number of Chats and Calls initiated, regardless of type (free/paid) or outcome (completed, failed, cancelled)',
    totalFailedChatCall: 'Total number of Chats and Calls that were not completed, including all failure reasons (user cancelled, consultant cancelled, technical issues, etc.)',
    totalCompletedChatCall: 'Total number of successfully completed Chats and Calls, including both free and paid',
    totalAttemptChat: 'Total number of Chats initiated, regardless of type (free/paid) or outcome (completed, failed, cancelled)',
    totalFailedChat: 'Total number of Chats that were not completed, including all failure reasons (user cancelled, consultant cancelled, technical issues, etc.)',
    totalCompletedChat: 'Total number of successfully completed Chats, including both free and paid',
    totalAttemptCall: 'Total number of Calls initiated, regardless of type (free/paid) or outcome (completed, failed, cancelled)',
    totalFailedCall: 'Total number of Calls that were not completed, including all failure reasons (user cancelled, consultant cancelled, technical issues, etc.)',
    totalCompletedCall: 'Total number of successfully completed Calls, including both free and paid',
    totalFreeChat: 'Total number of successfully completed free chat consultations',
    totalPaidChat: 'Total number of successfully completed paid chat consultations (all types included)',
    totalFirstTimeChat: 'Total number of successfully completed first-time paid chat consultations (user\'s first paid consultation)',
    totalRepeatChat: 'Total number of successfully completed repeat paid chat consultations (user has taken at least one paid consultation before)',
    totalFreeCall: 'Total number of successfully completed free Call consultations',
    totalPaidCall: 'Total number of successfully completed paid Call consultations (all types included)',
    totalFirstTimeCall: 'Total number of successfully completed first-time paid Call consultations (user\'s first paid consultation)',
    totalRepeatCall: 'Total number of successfully completed repeat paid Call consultations (user has taken at least one paid consultation before)',
    completionRatePercentage: 'Percentage of successfully completed consultations out of total attempts',
    freeChatPercentage: 'Percentage of free chat consultations out of total chat consultations',
    paidChatPercentage: 'Percentage of paid chat consultations out of total chat consultations',
    firstTimePaidChatPercentage: 'Percentage of first-time paid chat consultations out of total paid chat consultations',
    repeatPaidChatPercentage: 'Percentage of repeat paid chat consultations out of total paid chat consultations',
    freeCallPercentage: 'Percentage of free call consultations out of total call consultations',
    paidCallPercentage: 'Percentage of paid call consultations out of total call consultations',
    firstTimePaidCallPercentage: 'Percentage of first-time paid call consultations out of total paid call consultations',
    repeatPaidCallPercentage: 'Percentage of repeat paid call consultations out of total paid call consultations',
    totalChatCallTime: 'Combined total time spent on all Chats and Calls, including both free and paid.',
    averageChatCallTime: 'Average time spent per Chat or Call, including both free and paid.',
    totalFreeChatTime: 'Total time spent on free chats, i.e., total minutes of all free chat consultations',
    averageFreeChatTime: 'Average duration of a free chat = Total Time (Free Chat) / Total number of free chats',
    totalPaidChatTime: 'Total time spent on paid chats, i.e., total minutes of all paid chat consultations',
    averagePaidChatTime: 'Average duration of a paid chat = Total Time (Paid Chat) / Total number of paid chats',
    totalFirstTimePaidChatTime: 'Total time spent on first-time paid chats, i.e., total minutes from users taking their first paid consultation',
    averageFirstTimePaidChatTime: 'Average duration of a first-time paid chat = Total Time (1st Paid Chat) / Total number of first-time paid chats',
    totalRepeatChatTime: 'Total time spent on repeat paid chats, i.e., total minutes from users returning for another paid consultation',
    averageRepeatChatTime: 'Average duration of a repeat paid chat = Total Time (Repeat Paid Chat) / Total number of repeat paid chats',
    totalFreeCallTime: 'Total time spent on free calls, i.e., total minutes of all free call consultations',
    averageFreeCallTime: 'Average duration of a free call = Total Time (Free Call) / Total number of free calls',
    totalPaidCallTime: 'Total time spent on paid calls, i.e., total minutes of all paid call consultations',
    averagePaidCallTime: 'Average duration of a paid call = Total Time (Paid Call) / Total number of paid calls',
    totalFirstTimePaidCallTime: 'Total time spent on first-time paid calls, i.e., total minutes from users taking their first paid call consultation',
    averageFirstTimePaidCallTime: 'Average duration of a first-time paid call = Total Time (1st Paid Call) / Total number of first-time paid calls',
    totalRepeatCallTime: 'Total time spent on repeat paid calls, i.e., total minutes from users returning for another paid call consultation',
    averageRepeatCallTime: 'Average duration of repeat paid calls = Total Time (Repeat Paid Call) / Total number of repeat paid calls',
    totalChatCallRevenue: 'Combined Total Revenue for all paid Chats and Calls',
    averageChatCallRevenue: 'Average Revenue per paid Chat or Call = Total Revenue (Chat + Call) / Total number of paid consultations (Chat + Call)',
    totalPaidChatRevenue: 'Total Revenue on paid chats, i.e., Total Revenue on all paid chat consultations',
    averagePaidChatRevenue: 'Average Revenue on a paid chat = Total Revenue (Paid Chat) / Total number of paid chats',
    totalFirstTimePaidChatRevenue: 'Total Revenue on first-time paid chats, i.e., Total Revenue from users taking their first paid chat consultation',
    averageFirstTimePaidChatRevenue: 'Average Revenue on a first-time paid chat = Total Revenue (1st Paid Chat) / Total number of first-time paid chats',
    totalRepeatPaidChatRevenue: 'Total Revenue on repeat paid chats, i.e., Total Revenue from users returning for another paid chat consultation',
    averageRepeatPaidChatRevenue: 'Average Revenue on a repeat paid chat = Total Revenue (Repeat Paid Chat) / Total number of repeat paid chats',
    totalPaidCallRevenue: 'Total Revenue on paid calls, i.e., total revenue on all paid call consultations',
    averagePaidCallRevenue: 'Average Revenue on a paid call = Total Revenue (Paid Call) / Total number of paid calls',
    totalFirstTimePaidCallRevenue: 'Total Revenue on first-time paid calls, i.e., total Revenue from users taking their first paid call consultation',
    averageFirstTimePaidCallRevenue: 'Average Revenue on a first-time paid call = Total Revenue (1st Paid Call) / Total number of first-time paid calls',
    totalRepeatPaidCallRevenue: 'Total Revenue on repeat paid calls, i.e., total revenue from users returning for another paid call consultation',
    averageRepeatPaidCallRevenue: 'Average Revenue on a repeat paid call = Total Revenue (Repeat Paid Call) / Total number of repeat paid calls'
  }

  // Helper function to get column info
  const getColumnInfo = (columnKey) => {
    return columnInfo[columnKey] || 'No information available for this column'
  }

  // Column definitions - All 53 columns
  const columnDefinitions = {
    // Consultant Information (3 columns)
    consultantName: {
      label: 'Consultant Name',
      category: 'Consultant Information',
      type: 'text',
      description: 'Name of the consultant'
    },
    consultantType: {
      label: 'Consultant Type',
      category: 'Consultant Information',
      type: 'text',
      description: 'Type of consultation service provided by the consultant'
    },
    
    // Combined Attempts & Completion Metrics (3 columns)
    totalAttemptChatCall: {
      label: 'Total Attempt (Chat & Call)',
      category: 'NUMERICAL DATA - Summary of consultant activity shown in numbers',
      type: 'number',
      description: 'Total number of Chats and Calls initiated, regardless of type (free/paid) or outcome (completed, failed, cancelled)'
    },
    totalFailedChatCall: {
      label: 'Total Failed (Chat & Call)',
      category: 'NUMERICAL DATA - Summary of consultant activity shown in numbers',
      type: 'number',
      description: 'Total number of Chats and Calls that were not completed, including all failure reasons (user cancelled, consultant cancelled, technical issues, etc.)'
    },
    totalCompletedChatCall: {
      label: 'Total Completed (Chat & Call)',
      category: 'NUMERICAL DATA - Summary of consultant activity shown in numbers',
      type: 'number',
      description: 'Total number of successfully completed Chats and Calls, including both free and paid'
    },
    
    // Chat Attempts & Completion Metrics (3 columns)
    totalAttemptChat: {
      label: 'Total Attempt (Chat)',
      category: 'CHAT COLUMN',
      type: 'number',
      description: 'Total number of Chats initiated, regardless of type (free/paid) or outcome (completed, failed, cancelled)'
    },
    totalFailedChat: {
      label: 'Total Failed (Chat)',
      category: 'CHAT COLUMN',
      type: 'number',
      description: 'Total number of Chats that were not completed, including all failure reasons (user cancelled, consultant cancelled, technical issues, etc.)'
    },
    totalCompletedChat: {
      label: 'Total Completed (Chat)',
      category: 'CHAT COLUMN',
      type: 'number',
      description: 'Total number of successfully completed Chats, including both free and paid'
    },
    
    // Call Attempts & Completion Metrics (3 columns)
    totalAttemptCall: {
      label: 'Total Attempt (Call)',
      category: 'CALL COLUMN',
      type: 'number',
      description: 'Total number of Calls initiated, regardless of type (free/paid) or outcome (completed, failed, cancelled)'
    },
    totalFailedCall: {
      label: 'Total Failed (Call)',
      category: 'CALL COLUMN',
      type: 'number',
      description: 'Total number of Calls that were not completed, including all failure reasons (user cancelled, consultant cancelled, technical issues, etc.)'
    },
    totalCompletedCall: {
      label: 'Total Completed (Call)',
      category: 'CALL COLUMN',
      type: 'number',
      description: 'Total number of successfully completed Calls, including both free and paid'
    },
    
    // Chat Metrics - Detailed (4 columns)
    totalFreeChat: {
      label: 'Total Free Chat',
      category: 'CHAT COLUMN',
      type: 'number',
      description: 'Total number of successfully completed free chat consultations'
    },
    totalPaidChat: {
      label: 'Total Paid Chat',
      category: 'CHAT COLUMN',
      type: 'number',
      description: 'Total number of successfully completed paid chat consultations (all types included)'
    },
    totalFirstTimeChat: {
      label: 'Total 1st Paid Chat',
      category: 'CHAT COLUMN',
      type: 'number',
      description: 'Total number of successfully completed first-time paid chat consultations (user\'s first paid consultation)'
    },
    totalRepeatChat: {
      label: 'Total Repeat Paid Chat',
      category: 'CHAT COLUMN',
      type: 'number',
      description: 'Total number of successfully completed repeat paid chat consultations (user has taken at least one paid consultation before)'
    },
    
    // Call Metrics - Detailed (4 columns)
    totalFreeCall: {
      label: 'Total Free Call',
      category: 'CALL COLUMN',
      type: 'number',
      description: 'Total number of successfully completed free Call consultations'
    },
    totalPaidCall: {
      label: 'Total Paid Call',
      category: 'CALL COLUMN',
      type: 'number',
      description: 'Total number of successfully completed paid Call consultations (all types included)'
    },
    totalFirstTimeCall: {
      label: 'Total 1st Paid Call',
      category: 'CALL COLUMN',
      type: 'number',
      description: 'Total number of successfully completed first-time paid Call consultations (user\'s first paid consultation)'
    },
    totalRepeatCall: {
      label: 'Total Repeat Paid Call',
      category: 'CALL COLUMN',
      type: 'number',
      description: 'Total number of successfully completed repeat paid Call consultations (user has taken at least one paid consultation before)'
    },
    
    // Completion Rates (2 columns)
    completionRatePercentage: {
      label: 'Completion Rate (%)',
      category: 'Completion Rates',
      type: 'percentage',
      description: 'Percentage of successfully completed consultations out of total attempts'
    },
    // completionRateNumber: {
    //   label: 'Completion Rate (Number)',
    //   category: 'Completion Rates',
    //   type: 'number',
    //   description: 'Number of successfully completed consultations out of total attempts'
    // },
    
    // Chat Percentage Analysis (4 columns)
    freeChatPercentage: {
      label: 'Free Chat Percentage',
      category: 'Chat Percentage Analysis',
      type: 'percentage',
      description: 'Percentage of free chat consultations out of total chat consultations'
    },
    paidChatPercentage: {
      label: 'Paid Chat Percentage',
      category: 'Chat Percentage Analysis',
      type: 'percentage',
      description: 'Percentage of paid chat consultations out of total chat consultations'
    },
    firstTimePaidChatPercentage: {
      label: 'First Time Paid Chat Percentage',
      category: 'Chat Percentage Analysis',
      type: 'percentage',
      description: 'Percentage of first-time paid chat consultations out of total paid chat consultations'
    },
    repeatPaidChatPercentage: {
      label: 'Repeat Paid Chat Percentage',
      category: 'Chat Percentage Analysis',
      type: 'percentage',
      description: 'Percentage of repeat paid chat consultations out of total paid chat consultations'
    },
    
    // Call Percentage Analysis (4 columns)
    freeCallPercentage: {
      label: 'Free Call Percentage',
      category: 'Call Percentage Analysis',
      type: 'percentage',
      description: 'Percentage of free call consultations out of total call consultations'
    },
    paidCallPercentage: {
      label: 'Paid Call Percentage',
      category: 'Call Percentage Analysis',
      type: 'percentage',
      description: 'Percentage of paid call consultations out of total call consultations'
    },
    firstTimePaidCallPercentage: {
      label: 'First Time Paid Call Percentage',
      category: 'Call Percentage Analysis',
      type: 'percentage',
      description: 'Percentage of first-time paid call consultations out of total paid call consultations'
    },
    repeatPaidCallPercentage: {
      label: 'Repeat Paid Call Percentage',
      category: 'Call Percentage Analysis',
      type: 'percentage',
      description: 'Percentage of repeat paid call consultations out of total paid call consultations'
    },
    
    // General Time Metrics (Chat + Call combined)
    totalChatCallTime: {
      label: 'Total Time (Chat + Call)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Combined total time spent on all Chats and Calls, including both free and paid.'
    },
    averageChatCallTime: {
      label: 'Avg. Time (Chat + Call)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Average time spent per Chat or Call, including both free and paid.'
    },
    
    // Chat Time Metrics (8 columns)
    totalFreeChatTime: {
      label: 'Total Time (Free Chat)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Total time spent on free chats, i.e., total minutes of all free chat consultations'
    },
    totalPaidChatTime: {
      label: 'Total Time (Paid Chat)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Total time spent on paid chats, i.e., total minutes of all paid chat consultations'
    },
    averageFreeChatTime: {
      label: 'Avg. Time (Free Chat)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Average duration of a free chat = Total Time (Free Chat) / Total number of free chats'
    },
    averagePaidChatTime: {
      label: 'Avg. Time (Paid Chat)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Average duration of a paid chat = Total Time (Paid Chat) / Total number of paid chats'
    },
    totalFirstTimePaidChatTime: {
      label: 'Total Time (1st Paid Chat)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Total time spent on first-time paid chats, i.e., total minutes from users taking their first paid consultation'
    },
    averageFirstTimePaidChatTime: {
      label: 'Avg. Time (1st Paid Chat)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Average duration of a first-time paid chat = Total Time (1st Paid Chat) / Total number of first-time paid chats'
    },
    totalRepeatChatTime: {
      label: 'Total Time (Repeat Paid Chat)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Total time spent on repeat paid chats, i.e., total minutes from users returning for another paid consultation'
    },
    averageRepeatChatTime: {
      label: 'Avg. Time (Repeat Paid Chat)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Average duration of a repeat paid chat = Total Time (Repeat Paid Chat) / Total number of repeat paid chats'
    },
    
    // Call Time Metrics (6 columns)
    totalFreeCallTime: {
      label: 'Total Time (Free Call)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Total time spent on free calls, i.e., total minutes of all free call consultations'
    },
    totalPaidCallTime: {
      label: 'Total Time (Paid Call)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Total time spent on paid calls, i.e., total minutes of all paid call consultations'
    },
    averageFreeCallTime: {
      label: 'Avg. Time (Free Call)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Average duration of a free call = Total Time (Free Call) / Total number of free calls'
    },
    averagePaidCallTime: {
      label: 'Avg. Time (Paid Call)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Average duration of a paid call = Total Time (Paid Call) / Total number of paid calls'
    },
    totalFirstTimePaidCallTime: {
      label: 'Total Time (1st Paid Call)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Total time spent on first-time paid calls, i.e., total minutes from users taking their first paid call consultation'
    },
    averageFirstTimePaidCallTime: {
      label: 'Avg. Time (1st Paid Call)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Average duration of a first-time paid call = Total Time (1st Paid Call) / Total number of first-time paid calls'
    },
    totalRepeatCallTime: {
      label: 'Total Time (Repeat Paid Call)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Total time spent on repeat paid calls, i.e., total minutes from users returning for another paid call consultation'
    },
    averageRepeatCallTime: {
      label: 'Avg. Time (Repeat Paid Call)',
      category: 'TIME SPEND DATA - Summary of consultant activity shown in time spent',
      type: 'time',
      description: 'Average duration of repeat paid calls = Total Time (Repeat Paid Call) / Total number of repeat paid calls'
    },
    
    // General Revenue Metrics (Chat + Call combined)
    totalChatCallRevenue: {
      label: 'Total Revenue (Chat + Call)',
      category: 'REVENUE DATA - Summary of consultant activity shown in money spent',
      type: 'currency',
      description: 'Combined Total Revenue for all paid Chats and Calls'
    },
    averageChatCallRevenue: {
      label: 'Avg. Revenue (Chat + Call)',
      category: 'REVENUE DATA - Summary of consultant activity shown in money spent',
      type: 'currency',
      description: 'Average Revenue per paid Chat or Call = Total Revenue (Chat + Call) / Total number of paid consultations (Chat + Call)'
    },
    
    // Chat Revenue Metrics (6 columns)
    totalPaidChatRevenue: {
      label: 'Total Revenue (Paid Chat)',
      category: 'REVENUE DATA - Summary of consultant activity shown in money spent',
      type: 'currency',
      description: 'Total Revenue on paid chats, i.e., Total Revenue on all paid chat consultations'
    },
    totalFirstTimePaidChatRevenue: {
      label: 'Total Revenue (1st Paid Chat)',
      category: 'REVENUE DATA - Summary of consultant activity shown in money spent',
      type: 'currency',
      description: 'Total Revenue on first-time paid chats, i.e., Total Revenue from users taking their first paid chat consultation'
    },
    totalRepeatPaidChatRevenue: {
      label: 'Total Revenue (Repeat Paid Chat)',
      category: 'REVENUE DATA - Summary of consultant activity shown in money spent',
      type: 'currency',
      description: 'Total Revenue on repeat paid chats, i.e., Total Revenue from users returning for another paid chat consultation'
    },

    averagePaidChatRevenue: {
      label: 'Avg. Revenue (Paid Chat)',
      category: 'REVENUE DATA - Summary of consultant activity shown in money spent',
      type: 'currency',
      description: 'Average Revenue on a paid chat = Total Revenue (Paid Chat) / Total number of paid chats'
    },
    averageFirstTimePaidChatRevenue: {
      label: 'Avg. Revenue (1st Paid Chat)',
      category: 'REVENUE DATA - Summary of consultant activity shown in money spent',
      type: 'currency',
      description: 'Average Revenue on a first-time paid chat = Total Revenue (1st Paid Chat) / Total number of first-time paid chats'
    },
    averageRepeatPaidChatRevenue: {
      label: 'Avg. Revenue (Repeat Paid Chat)',
      category: 'REVENUE DATA - Summary of consultant activity shown in money spent',
      type: 'currency',
      description: 'Average Revenue on a repeat paid chat = Total Revenue (Repeat Paid Chat) / Total number of repeat paid chats'
    },
    
    // Call Revenue Metrics (6 columns)
    totalPaidCallRevenue: {
      label: 'Total Revenue (Paid Call)',
      category: 'REVENUE DATA - Summary of consultant activity shown in money spent',
      type: 'currency',
      description: 'Total Revenue on paid calls, i.e., total revenue on all paid call consultations'
    },
    totalFirstTimePaidCallRevenue: {
      label: 'Total Revenue (1st Paid Call)',
      category: 'REVENUE DATA - Summary of consultant activity shown in money spent',
      type: 'currency',
      description: 'Total Revenue on first-time paid calls, i.e., total Revenue from users taking their first paid call consultation'
    },
    totalRepeatPaidCallRevenue: {
      label: 'Total Revenue (Repeat Paid Call)',
      category: 'REVENUE DATA - Summary of consultant activity shown in money spent',
      type: 'currency',
      description: 'Total Revenue on repeat paid calls, i.e., total revenue from users returning for another paid call consultation'
    },
    averagePaidCallRevenue: {
      label: 'Avg. Revenue (Paid Call)',
      category: 'REVENUE DATA - Summary of consultant activity shown in money spent',
      type: 'currency',
      description: 'Average Revenue on a paid call = Total Revenue (Paid Call) / Total number of paid calls'
    },
    averageFirstTimePaidCallRevenue: {
      label: 'Avg. Revenue (1st Paid Call)',
      category: 'REVENUE DATA - Summary of consultant activity shown in money spent',
      type: 'currency',
      description: 'Average Revenue on a first-time paid call = Total Revenue (1st Paid Call) / Total number of first-time paid calls'
    },
    averageRepeatPaidCallRevenue: {
      label: 'Avg. Revenue (Repeat Paid Call)',
      category: 'REVENUE DATA - Summary of consultant activity shown in money spent',
      type: 'currency',
      description: 'Average Revenue on a repeat paid call = Total Revenue (Repeat Paid Call) / Total number of repeat paid calls'
    },
    
    // Overall Performance Metrics (0 columns)
  }

  // Get columns based on active tab
  const getColumnsForActiveTab = () => {
    const tabMappings = {
      0: 'all',    // Combined view
      1: 'chat',   // Chat only
      2: 'call'    // Call only
    }
    
    const currentTab = tabMappings[activeTab]
    return Object.keys(columnDefinitions).filter(columnKey => {
      const category = columnDefinitions[columnKey].category
      if (currentTab === 'all') return true
      if (currentTab === 'chat') {
        return category === 'CHAT COLUMN' || 
               category === 'Consultant Information' || 
               category === 'Completion Rates' || 
               category === 'Overall Performance Metrics' ||
               category === 'NUMERICAL DATA - Summary of consultant activity shown in numbers' ||
               category === 'TIME SPEND DATA - Summary of consultant activity shown in time spent' ||
               category === 'REVENUE DATA - Summary of consultant activity shown in money spent' ||
               category === 'Chat Percentage Analysis'
      }
      if (currentTab === 'call') {
        return category === 'CALL COLUMN' || 
               category === 'Consultant Information' || 
               category === 'Completion Rates' || 
               category === 'Overall Performance Metrics' ||
               category === 'NUMERICAL DATA - Summary of consultant activity shown in numbers' ||
               category === 'TIME SPEND DATA - Summary of consultant activity shown in time spent' ||
               category === 'REVENUE DATA - Summary of consultant activity shown in money spent' ||
               category === 'Call Percentage Analysis'
      }
      return false
    })
  }

  // Get visible columns for current tab
  const getVisibleColumnsForCurrentTab = () => {
    const tabColumns = getColumnsForActiveTab()
    const dynamicColumns = getDynamicColumns()
    const visible = {}
    
    tabColumns.forEach(columnKey => {
      visible[columnKey] = visibleColumns[columnKey]
    })
    
    // Add dynamic columns as always visible
    Object.keys(dynamicColumns).forEach(columnKey => {
      visible[columnKey] = true
    })
    
    return visible
  }

  // Get ordered columns for display
  const getOrderedColumns = () => {
    const allColumns = getAllColumnsWithDynamic()
    const orderedColumns = []
    
    // Define the order according to the document sequence
    const columnOrder = [
      // Consultant Information
      'consultantName',
      'consultantType',
      
      // Dynamic filter columns
      'selectedConsultantType',
      'consultantGender',
      'selectedProblemType',
      'selectedUserGender',
      'selectedTimeRange',
      
      // NUMERICAL DATA - Summary of consultant activity shown in numbers
      'totalAttemptChatCall',
      'totalFailedChatCall',
      'totalCompletedChatCall',
      
      // CHAT COLUMN
      'totalAttemptChat',
      'totalFailedChat',
      'totalCompletedChat',
      'totalFreeChat',
      'totalPaidChat',
      'totalFirstTimeChat',
      'totalRepeatChat',
      
      // CALL COLUMN
      'totalAttemptCall',
      'totalFailedCall',
      'totalCompletedCall',
      'totalFreeCall',
      'totalPaidCall',
      'totalFirstTimeCall',
      'totalRepeatCall',
      
      // Completion Rates
      'completionRatePercentage',
      'completionRateNumber',
      
      // Chat Percentage Analysis
      'freeChatPercentage',
      'paidChatPercentage',
      'firstTimePaidChatPercentage',
      'repeatPaidChatPercentage',
      
      // Call Percentage Analysis
      'freeCallPercentage',
      'paidCallPercentage',
      'firstTimePaidCallPercentage',
      'repeatPaidCallPercentage',
      
      // TIME SPEND DATA - Summary of consultant activity shown in time spent
      // General Metrics (Chat + Call combined)
      'totalChatCallTime',
      'averageChatCallTime',
      // Chat (Time Spent)
      'totalFreeChatTime',
      'averageFreeChatTime',
      'totalPaidChatTime',
      'averagePaidChatTime',
      'totalFirstTimePaidChatTime',
      'averageFirstTimePaidChatTime',
      'totalRepeatChatTime',
      'averageRepeatChatTime',
      // Call (Time Spent)
      'totalFreeCallTime',
      'averageFreeCallTime',
      'totalPaidCallTime',
      'averagePaidCallTime',
      'totalFirstTimePaidCallTime',
      'averageFirstTimePaidCallTime',
      'totalRepeatCallTime',
      'averageRepeatCallTime',
      
      // REVENUE DATA - Summary of consultant activity shown in money spent
      // General Revenue Metrics (Chat + Call combined)
      'totalChatCallRevenue',
      'averageChatCallRevenue',
      // Chat Revenue Metrics
      'totalPaidChatRevenue',
      'averagePaidChatRevenue',
      'totalFirstTimePaidChatRevenue',
      'averageFirstTimePaidChatRevenue',
      'totalRepeatPaidChatRevenue',
      'averageRepeatPaidChatRevenue',
      // Call Revenue Metrics
      'totalPaidCallRevenue',
      'averagePaidCallRevenue',
      'totalFirstTimePaidCallRevenue',
      'averageFirstTimePaidCallRevenue',
      'totalRepeatPaidCallRevenue',
      'averageRepeatPaidCallRevenue'
    ]
    
    // Add columns in the specified order
    columnOrder.forEach(columnKey => {
      if (allColumns[columnKey]) {
        orderedColumns.push(columnKey)
      }
    })
    
    // Add any remaining columns that might not be in the order list
    Object.keys(allColumns).forEach(columnKey => {
      if (!orderedColumns.includes(columnKey)) {
        orderedColumns.push(columnKey)
      }
    })
    
    return orderedColumns
  }

  // Get columns grouped by category for display
  const getColumnsGroupedByCategory = () => {
    const allColumns = getAllColumnsWithDynamic()
    const visibleColumns = getVisibleColumnsForCurrentTab()
    const groupedColumns = {}
    
    getOrderedColumns().forEach(columnKey => {
      if (visibleColumns[columnKey] && allColumns[columnKey]) {
        const category = allColumns[columnKey].category
        if (!groupedColumns[category]) {
          groupedColumns[category] = []
        }
        groupedColumns[category].push(columnKey)
      }
    })
    
    return groupedColumns
  }

  // Dynamic columns based on selected filters
  const getDynamicColumns = () => {
    const dynamicColumns = {}
    
    // Add consultant type column if filter is selected
    if (consultantType) {
      dynamicColumns.selectedConsultantType = {
        label: `Selected Type: ${consultantType}`,
        category: 'Filter Applied',
        type: 'text',
        isDynamic: true
      }
    }
    
    // Add problem type column if filter is selected
    if (problemType) {
      dynamicColumns.selectedProblemType = {
        label: `Selected Problem: ${problemType}`,
        category: 'Filter Applied',
        type: 'text',
        isDynamic: true
      }
    }
    
    // Add consultant gender column if filter is selected
    if (consultantGender) {
      dynamicColumns.consultantGender = {
        label: 'Gender',
        category: 'Consultant Information',
        type: 'text',
        isDynamic: true
      }
    }
    
    // Add user gender column if filter is selected
    if (userGender) {
      dynamicColumns.selectedUserGender = {
        label: `User Gender: ${userGender}`,
        category: 'Filter Applied',
        type: 'text',
        isDynamic: true
      }
    }
    
    // Add time range column if filter is selected
    if (timeRange) {
      dynamicColumns.selectedTimeRange = {
        label: `Time Range: ${timeRange}`,
        category: 'Filter Applied',
        type: 'text',
        isDynamic: true
      }
    }
    
    return dynamicColumns
  }

  // Get all columns including dynamic ones
  const getAllColumnsWithDynamic = () => {
    const dynamicColumns = getDynamicColumns()
    return { ...columnDefinitions, ...dynamicColumns }
  }

  // Get all columns grouped by category (both visible and hidden) for current tab
  const getAllColumnsByCategory = () => {
    const categories = {}
    const tabColumns = getColumnsForActiveTab()
    const dynamicColumns = getDynamicColumns()
    const allColumns = { ...columnDefinitions, ...dynamicColumns }
    
    tabColumns.forEach(columnKey => {
      const columnDef = allColumns[columnKey]
      if (columnDef) {
        const category = columnDef.category
        if (!categories[category]) {
          categories[category] = []
        }
        categories[category].push({
          key: columnKey,
          ...columnDef
        })
      }
    })
    
    // Add dynamic columns that are not in tab columns but should be shown
    Object.keys(dynamicColumns).forEach(columnKey => {
      const columnDef = dynamicColumns[columnKey]
      const category = columnDef.category
      if (!categories[category]) {
        categories[category] = []
      }
      categories[category].push({
        key: columnKey,
        ...columnDef
      })
    })
    
    return categories
  }

  // Handle column selection
  const handleColumnToggle = (columnKey) => {
    setVisibleColumns(prev => ({
      ...prev,
      [columnKey]: !prev[columnKey]
    }))
  }

  // Handle select all columns
  const handleSelectAllColumns = () => {
    const allColumns = {}
    const allColumnsWithDynamic = getAllColumnsWithDynamic()
    Object.keys(allColumnsWithDynamic).forEach(key => {
      allColumns[key] = true
    })
    setVisibleColumns(allColumns)
  }

  // Handle deselect all columns
  const handleDeselectAllColumns = () => {
    const noColumns = {}
    const allColumnsWithDynamic = getAllColumnsWithDynamic()
    Object.keys(allColumnsWithDynamic).forEach(key => {
      noColumns[key] = false
    })
    setVisibleColumns(noColumns)
  }

  // Handle select all in category
  const handleSelectAllInCategory = (category) => {
    setVisibleColumns(prev => {
      const updated = { ...prev }
      const allColumnsWithDynamic = getAllColumnsWithDynamic()
      Object.keys(allColumnsWithDynamic).forEach(key => {
        if (allColumnsWithDynamic[key].category === category) {
          updated[key] = true
        }
      })
      return updated
    })
  }

  // Handle deselect all in category
  const handleDeselectAllInCategory = (category) => {
    setVisibleColumns(prev => {
      const updated = { ...prev }
      const allColumnsWithDynamic = getAllColumnsWithDynamic()
      Object.keys(allColumnsWithDynamic).forEach(key => {
        if (allColumnsWithDynamic[key].category === category) {
          updated[key] = false
        }
      })
      return updated
    })
  }

  // Get column count
  const getVisibleColumnCount = () => {
    return Object.values(visibleColumns).filter(Boolean).length
  }

  // Fetch consultant insights data
  const fetchConsultantInsights = async (page = 1, search = '', start = '', end = '', filters = {}) => {
    try {
      showLoader()
      const sendData = {
        page,
        pageSize,
        search,
        ...(start && { startDate: start }),
        ...(end && { endDate: end }),
        ...(filters.timeRange && { timeRange: filters.timeRange }),
        ...(filters.consultantType && { consultantType: filters.consultantType }),
        ...(filters.problemType && { problemType: filters.problemType }),
        ...(filters.consultantGender && { consultantGender: filters.consultantGender }),
        ...(filters.userGender && { userGender: filters.userGender }),
        ...(insightType === 'custom' && selectedConsultants.length > 0 && { consultantIds: selectedConsultants }),
        ...(insightType === 'single' && singleConsultant && { consultantId: singleConsultant })
      }
      console.log("sendData", sendData)
      const { data } = await fetchConsultantInsightsApi(sendData)
      if (data?.code === 200) {
        setInsightsData(data?.result || {})
        setConsultationList(data?.result?.consultations || [])
        setTotal(data?.result?.pagination?.totalDocuments || 0)
      } else {
        setInsightsData({})
        setConsultationList([])
        setTotal(0)
        toastMessage(data?.message, "error", "ConsultantInsight")
      }
    } catch (error) {
      console.error("Error fetching consultant insights:", error)
      toastMessage("Failed to fetch consultant insights data", "error", "ConsultantInsight")
      setInsightsData({})
      setConsultationList([])
      setTotal(0)
    } finally {
      hideLoader()
    }
  }

  useEffect(() => {
    const filters = {
      timeRange,
      consultantType,
      problemType,
      consultantGender,
      userGender
    }
    console.log('Frontend filters being sent:', filters);
    fetchConsultantInsights(activePage, searchQuery, startDate, endDate, filters)
  }, [activePage, pageSize, searchQuery, startDate, endDate, timeRange, consultantType, problemType, consultantGender, userGender, insightType, selectedConsultants, singleConsultant])

  // Update select all state when data changes
  useEffect(() => {
    if (consultationList.length > 0) {
      const allSelected = consultationList.every(item => selectedTableRows.includes(item._id))
      const someSelected = consultationList.some(item => selectedTableRows.includes(item._id))
      
      if (allSelected && consultationList.length > 0) {
        setSelectAllRows(true)
      } else if (someSelected) {
        setSelectAllRows(false)
      } else {
        setSelectAllRows(false)
      }
    }
  }, [consultationList, selectedTableRows])

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber)
  }

  // Handle page size change
  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize)
    setActivePage(1) // Reset to first page when changing page size
  }

  // Handle search
  const handleSearch = (event) => {
    setSearchQuery(event.target.value)
    setActivePage(1)
  }

  // Handle date change
  const handleDateChange = (type, value) => {
    if (type === 'start') {
      setStartDate(value)
    } else {
      setEndDate(value)
    }
    setActivePage(1)
  }

  // Handle filter changes
  const handleTimeRangeChange = (value) => {
    setTimeRange(value)
    setActivePage(1)
  }

  const handleConsultantTypeChange = (value) => {
    setConsultantType(value)
    setActivePage(1)
  }

  const handleProblemTypeChange = (value) => {
    setProblemType(value)
    setActivePage(1)
  }

  const handleConsultantGenderChange = (value) => {
    setConsultantGender(value)
    setActivePage(1)
  }

  const handleUserGenderChange = (value) => {
    setUserGender(value)
    setActivePage(1)
  }

  // Clear filters
  const clearFilters = () => {
    setSearchQuery('')
    setStartDate('')
    setEndDate('')
    setTimeRange('')
    setConsultantType('')
    setProblemType('')
    setConsultantGender('')
    setUserGender('')
    setInsightType('all')
    setSelectedConsultants([])
    setSingleConsultant('')
    setSelectedTableRows([])
    setSelectAllRows(false)
    setActivePage(1)
    setPageSize(10)
  }

  // Handle insight type change
  const handleInsightTypeChange = (value) => {
    setInsightType(value)
    setSelectedConsultants([])
    setSingleConsultant('')
    setActivePage(1)
  }

  // Handle consultant selection for custom insights
  const handleConsultantSelection = (consultantId) => {
    setSelectedConsultants(prev => {
      if (prev.includes(consultantId)) {
        return prev.filter(id => id !== consultantId)
      } else {
        return [...prev, consultantId]
      }
    })
  }

  // Handle single consultant selection
  const handleSingleConsultantChange = (consultantId) => {
    setSingleConsultant(consultantId)
    setActivePage(1)
  }

  // Handle table row selection
  const handleTableRowSelection = (consultantId) => {
    setSelectedTableRows(prev => {
      if (prev.includes(consultantId)) {
        return prev.filter(id => id !== consultantId)
      } else {
        return [...prev, consultantId]
      }
    })
  }

  // Handle select all table rows
  const handleSelectAllTableRows = () => {
    if (selectAllRows) {
      setSelectedTableRows([])
      setSelectAllRows(false)
    } else {
      const allConsultantIds = consultationList.map(item => item._id)
      setSelectedTableRows(allConsultantIds)
      setSelectAllRows(true)
    }
  }

  // Get selected consultants count
  const getSelectedConsultantsCount = () => {
    return selectedTableRows.length
  }

  // Get category color for visual differentiation - matching user insight colors
  const getCategoryColor = (category) => {
    const colorMap = {
      'Consultant Information': '#e3f2fd', // Light blue
      'NUMERICAL DATA - Summary of consultant activity shown in numbers': '#e3f2fd', // Light blue
      'CHAT COLUMN': '#c8e6c9', // Light green
      'CALL COLUMN': '#ffe0b2', // Light orange
      'Completion Rates': '#e1bee7', // Light purple
      'Chat Percentage Analysis': '#c8e6c9', // Light green
      'Call Percentage Analysis': '#ffe0b2', // Light orange
      'TIME SPEND DATA - Summary of consultant activity shown in time spent': '#e1bee7', // Light purple
      'REVENUE DATA - Summary of consultant activity shown in money spent': '#ECEDB0', // Light yellow
      'Overall Performance Metrics': '#fafafa', // Light grey
      'Filter Applied': '#fff3e0' // Light orange for dynamic columns
    }
    return colorMap[category] || '#fafafa'
  }

  // Get lighter background color for data rows - making them lighter than headers
  const getDataRowColor = (category) => {
    const colorMap = {
      'Consultant Information': '#f0f7ff', // Slightly darker light blue
      'NUMERICAL DATA - Summary of consultant activity shown in numbers': '#f0f7ff', // Slightly darker light blue
      'CHAT COLUMN': '#e8f5e8', // Slightly darker light green
      'CALL COLUMN': '#fff2e6', // Slightly darker light orange
      'Completion Rates': '#f0e8f0', // Slightly darker light purple
      'Chat Percentage Analysis': '#e8f5e8', // Slightly darker light green
      'Call Percentage Analysis': '#fff2e6', // Slightly darker light orange
      'TIME SPEND DATA - Summary of consultant activity shown in time spent': '#f0e8f0', // Slightly darker light purple
      'REVENUE DATA - Summary of consultant activity shown in money spent': '#fafce6', // Slightly darker light yellow
      'Overall Performance Metrics': '#fafafa', // Slightly darker light grey
      'Filter Applied': '#fff8e6' // Slightly darker light orange for dynamic columns
    }
    return colorMap[category] || '#fafafa'
  }

  // Get category border style for box-type grouping - matching user insight
  const getCategoryBorderStyle = (category) => {
    return '1px solid #333' // Dark border like user insight
  }

          // Get border style for individual columns - matching user insight exactly
        const getColumnBorderStyle = (category, isFirst, isLast) => {
          // Base border for all cells
          const baseBorder = '1px solid #e0e0e0'

          if (isFirst) {
            // First column of category - add left border to mark category boundary
            return {
              border: baseBorder,
              borderLeft: '2px solid #333'
            }
          } else {
            // All other columns - just base border
            return {
              border: baseBorder
            }
          }
        }

  // Get border color for category - matching user insight colors
  const getCategoryBorderColor = (category) => {
    const colorMap = {
      'Consultant Information': '#1976d2', // Blue
      'NUMERICAL DATA - Summary of consultant activity shown in numbers': '#1976d2', // Blue
      'CHAT COLUMN': '#2e7d32', // Green
      'CALL COLUMN': '#f57c00', // Orange
      'Completion Rates': '#7b1fa2', // Purple
      'Chat Percentage Analysis': '#2e7d32', // Green
      'Call Percentage Analysis': '#f57c00', // Orange
      'TIME SPEND DATA - Summary of consultant activity shown in time spent': '#7b1fa2', // Purple
      'REVENUE DATA - Summary of consultant activity shown in money spent': '#93960b', // Yellow
      'Overall Performance Metrics': '#333', // Dark grey
      'Filter Applied': '#f57c00' // Orange for dynamic columns
    }
    return colorMap[category] || '#333'
  }

  // Filter options
  const timeRangeOptions = [
    { value: 'today', label: 'Today' },
    { value: 'last7days', label: 'Last 7 Days' },
    { value: 'last30days', label: 'Last 30 Days' },
    { value: 'last60days', label: 'Last 60 Days' },
    { value: 'last90days', label: 'Last 90 Days' },
    { value: 'custom', label: 'Custom Range' }
  ]

  const consultantTypeOptions = [
    { value: 'astrology', label: 'Astrology' },
    { value: 'numerology', label: 'Numerology' },
    { value: 'palmistry', label: 'Palmistry' },
    { value: 'tarot', label: 'Tarot' },
    { value: 'vastu', label: 'Vastu' },
    { value: 'other', label: 'Other' }
  ]

  const problemTypeOptions = [
    { value: 'health', label: 'Health' },
    { value: 'finance', label: 'Finance' },
    { value: 'marriage', label: 'Marriage' },
    { value: 'relationship', label: 'Relationship' },
    { value: 'depression', label: 'Depression' },
    { value: 'other', label: 'Other' }
  ]

  const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'binary', label: 'Transgender' }
  ]

  // Format number for display with proper decimal handling
  const formatNumber = (value) => {
    if (!value || value === 0) return "0"
    const numValue = Number(value)
    // If it's a whole number, show without decimals
    if (numValue % 1 === 0) {
      return numValue.toString()
    }
    // If it has decimals, show up to 4 decimal places
    const decimalPlaces = Math.min((numValue.toString().split('.')[1] || '').length, 4)
    return numValue.toFixed(decimalPlaces)
  }
  
  // Format percentage for display (2 digits after decimal)
  const formatPercentage = (value) => {
    if (!value) return "0.00%"
    const numValue = Number(value)
    return `${numValue.toFixed(2)}%`
  }
  
  // Format time in minutes and seconds
  const formatTime = (seconds) => {
    if (!seconds || seconds === 0) return "0 min 0 sec"
    const numSeconds = Number(seconds)
    const minutes = Math.floor(numSeconds / 60)
    const remainingSeconds = Math.floor(numSeconds % 60)
    return `${minutes} min ${remainingSeconds} sec`
  }

  // Format currency with proper decimal handling
  const formatCurrency = (amount) => {
    if (!amount || amount === 0) return "₹0"
    const numAmount = Number(amount)
    // Always format to 2 decimal places for consistency
    const formatted = numAmount.toFixed(2)
    return `₹${formatted}`
  }

  // Calculate serial number
  const findSerialNumber = (index, currentPage, currentPageSize) => {
    return (currentPage - 1) * currentPageSize + index + 1
  }

  // Calculate totals for all consultants
  const calculateTotals = () => {
    if (!consultationList || consultationList.length === 0) return {}
    
    // Use the overallTotalDataConsultation data directly
    const overallData = insightsData?.overallTotalDataConsultation || {}
    
    const totals = {
      // Combined Attempts & Completion Metrics
      totalAttemptChatCall: overallData.totalAttemptChatCall || 0,
      totalFailedChatCall: overallData.totalFailedChatCall || 0,
      totalCompletedChatCall: (overallData.totalCompletedChat || 0) + (overallData.totalCompletedCall || 0),
      
      // Chat Attempts & Completion Metrics
      totalAttemptChat: overallData.totalAttemptChat || 0,
      totalFailedChat: overallData.totalFailedChat || 0,
      totalCompletedChat: overallData.totalCompletedChat || 0,
      
      // Call Attempts & Completion Metrics
      totalAttemptCall: (overallData.totalAttemptCall),
      totalFailedCall: overallData.totalFailedCall || 0,
      totalCompletedCall: (overallData.totalCompletedCall || 0),
      
      // Chat Metrics - Detailed
      totalFreeChat: overallData.totalFreeChat || 0,
      totalPaidChat: overallData.totalPaidChat || 0,
      totalFirstTimeChat: overallData.totalFirstTimeChat || 0,
      totalRepeatChat: overallData.totalRepeatChat || 0,
      
      // Call Metrics - Detailed
      totalFreeCall: overallData.totalFreeCall || 0,
      totalPaidCall: overallData.totalPaidCall || 0,
      totalFirstTimeCall: overallData.totalFirstTimeCall || 0,
      totalRepeatCall: overallData.totalRepeatCall || 0,
      
      // Completion Rates
      completionRatePercentage: overallData.completionRatePercentage || 0,
      completionRateNumber: overallData.completionRateNumber || 0,
      
      // Chat Percentage Analysis
      freeChatPercentage: overallData.freeChatPercentage || 0,
      paidChatPercentage: overallData.paidChatPercentage || 0,
      firstTimePaidChatPercentage: overallData.firstTimePaidChatPercentage || 0,
      repeatPaidChatPercentage: overallData.repeatPaidChatPercentage || 0,
      
      // Call Percentage Analysis
      freeCallPercentage: overallData.freeCallPercentage || 0,
      paidCallPercentage: overallData.paidCallPercentage || 0,
      firstTimePaidCallPercentage: overallData.firstTimePaidCallPercentage || 0,
      repeatPaidCallPercentage: overallData.repeatPaidCallPercentage || 0,
      
      // General Time Metrics (Chat + Call combined)
      totalChatCallTime: (overallData.totalFreeChatTime || 0) + (overallData.totalPaidChatTime || 0) + (overallData.totalFreeCallTime || 0) + (overallData.totalPaidCallTime || 0),
      averageChatCallTime: ((overallData.totalFreeChatTime || 0) + (overallData.totalPaidChatTime || 0) + (overallData.totalFreeCallTime || 0) + (overallData.totalPaidCallTime || 0)) / ((overallData.totalFreeChat || 0) + (overallData.totalPaidChat || 0) + (overallData.totalFreeCall || 0) + (overallData.totalPaidCall || 0)) || 0,
      
      // Chat Time Metrics
      totalFreeChatTime: overallData.totalFreeChatTime || 0,
      totalPaidChatTime: overallData.totalPaidChatTime || 0,
      averageFreeChatTime: overallData.totalFreeChatTime / overallData.totalFreeChat || 0,
      averagePaidChatTime: overallData.totalPaidChatTime / overallData.totalPaidChat || 0,
      totalFirstTimePaidChatTime: overallData.totalFirstTimePaidChatTime || (overallData.averageFirstTimePaidChatTime * overallData.totalFirstTimeChat) || 0,
      averageFirstTimePaidChatTime: overallData.totalFirstTimePaidChatTime / overallData.totalFirstTimeChat || 0,
      totalRepeatChatTime: overallData.totalRepeatChatTime || 0,
      averageRepeatChatTime: overallData.totalRepeatChatTime / overallData.totalRepeatChat || 0,
      
      // Call Time Metrics
      totalFreeCallTime: overallData.totalFreeCallTime || 0,
      totalPaidCallTime: overallData.totalPaidCallTime || 0,
      averageFreeCallTime: overallData.totalFreeCallTime / overallData.totalFreeCall || 0,
      averagePaidCallTime: overallData.totalPaidCallTime / overallData.totalPaidCall || 0,
      totalFirstTimePaidCallTime: overallData.totalFirstTimePaidCallTime || (overallData.averageFirstTimePaidCallTime * overallData.totalFirstTimeCall) || 0,
      averageFirstTimePaidCallTime: overallData.totalFirstTimePaidCallTime / overallData.totalFirstTimeCall || 0,
      totalRepeatCallTime: overallData.totalRepeatCallTime || 0,
      averageRepeatCallTime: overallData.totalRepeatCallTime / overallData.totalRepeatCall || 0,
      
      // General Revenue Metrics (Chat + Call combined)
      totalChatCallRevenue: (overallData.totalChatRevenue || 0) + (overallData.totalCallRevenue || 0),
      averageChatCallRevenue: ((overallData.totalChatRevenue || 0) + (overallData.totalCallRevenue || 0)) / ((overallData.totalPaidChat || 0) + (overallData.totalPaidCall || 0)) || 0,
      
      // Chat Revenue Metrics
      totalPaidChatRevenue: overallData.totalPaidChatRevenue || 0,
      averagePaidChatRevenue: overallData.totalPaidChatRevenue / overallData.totalPaidChat || 0,
      totalFirstTimePaidChatRevenue: overallData.totalFirstTimePaidChatRevenue || 0,
      averageFirstTimePaidChatRevenue: overallData.totalFirstTimePaidChatRevenue / overallData.totalFirstTimeChat || 0,
      totalRepeatPaidChatRevenue: overallData.totalRepeatPaidChatRevenue || 0,
      averageRepeatPaidChatRevenue: overallData.totalRepeatPaidChatRevenue / overallData.totalRepeatChat || 0,
      
      // Call Revenue Metrics
      totalPaidCallRevenue: overallData.totalPaidCallRevenue || 0,
      averagePaidCallRevenue: overallData.totalPaidCallRevenue / overallData.totalPaidCall || 0,
      totalFirstTimePaidCallRevenue: overallData.totalFirstTimePaidCallRevenue || 0,
      averageFirstTimePaidCallRevenue: overallData.averageFirstTimePaidCallRevenue,
      totalRepeatPaidCallRevenue: overallData.totalRepeatPaidCallRevenue || 0,
      averageRepeatPaidCallRevenue: overallData.averageRepeatPaidCallRevenue || 0
    }
    
    return totals
  }

  // Render totals value based on column type
  const renderTotalsValue = (totals, columnKey) => {
    const allColumns = getAllColumnsWithDynamic()
    const columnDef = allColumns[columnKey]
    
    if (!columnDef) return 'N/A'
    
    // Handle dynamic columns - show filter value
    if (columnDef?.isDynamic) {
      if (columnKey === 'consultantGender') {
        return consultantGender || 'N/A'
      }
      return columnDef.label.split(': ')[1] || 'N/A'
    }
    
    // Handle combined chat/call columns - now directly from API
    if (columnKey === 'totalAttemptChatCall') {
      return totals.totalAttemptChatCall || 0
    }
    
    if (columnKey === 'totalFailedChatCall') {
      return totals.totalFailedChatCall || 0
    }
    
    if (columnKey === 'totalCompletedChatCall') {
      return totals.totalCompletedChatCall || 0
    }
    
    // Handle chat-specific attempt columns
    if (columnKey === 'totalAttemptChat') {
      return totals.totalAttemptChat || 0
    }
    
    if (columnKey === 'totalFailedChat') {
      return totals.totalFailedChat || 0
    }
    
    if (columnKey === 'totalCompletedChat') {
      return totals.totalCompletedChat || 0
    }
    
    // Handle call-specific attempt columns
    if (columnKey === 'totalAttemptCall') {
      return totals.totalAttemptCall || 0
    }
    
    if (columnKey === 'totalFailedCall') {
      return totals.totalAttemptCall - totals.totalCompletedCall || 0
    }
    
    if (columnKey === 'totalCompletedCall') {
      return totals.totalCompletedCall || 0
    }
    
    // Get the value from totals
    const value = totals[columnKey]
    
    // Handle combined time columns for totals
    if (columnKey === 'totalChatCallTime') {
      const totalTime = (totals.totalFreeChatTime || 0) + (totals.totalPaidChatTime || 0) + (totals.totalFreeCallTime || 0) + (totals.totalPaidCallTime || 0)
      return formatTime(totalTime)
    }
    
    if (columnKey === 'averageChatCallTime') {
      const totalTime = (totals.totalFreeChatTime || 0) + (totals.totalPaidChatTime || 0) + (totals.totalFreeCallTime || 0) + (totals.totalPaidCallTime || 0)
      const totalConsultations = (totals.totalFreeChat || 0) + (totals.totalPaidChat || 0) + (totals.totalFreeCall || 0) + (totals.totalPaidCall || 0)
      const avgTime = totalConsultations > 0 ? totalTime / totalConsultations : 0
      return formatTime(avgTime)
    }
    
    // Handle first-time paid time columns for totals
    if (columnKey === 'totalFirstTimePaidChatTime') {
      const totalTime = totals.totalFirstTimePaidChatTime || (totals.averageFirstTimePaidChatTime * totals.totalFirstTimeChat) || 0
      return formatTime(totalTime)
    }
    
    if (columnKey === 'averageFirstTimePaidChatTime') {
      return formatTime(totals.averageFirstTimePaidChatTime || 0)
    }
    
    if (columnKey === 'totalFirstTimePaidCallTime') {
      const totalTime = totals.totalFirstTimePaidCallTime || (totals.averageFirstTimePaidCallTime * totals.totalFirstTimeCall) || 0
      return formatTime(totalTime)
    }
    
    if (columnKey === 'averageFirstTimePaidCallTime') {
      return formatTime(totals.averageFirstTimePaidCallTime || 0)
    }
    
    // Handle combined revenue columns for totals
    if (columnKey === 'totalChatCallRevenue') {
      return formatCurrency(totals.totalChatCallRevenue || 0)
    }
    
    if (columnKey === 'averageChatCallRevenue') {
      return formatCurrency(totals.averageChatCallRevenue || 0)
    }
    
    switch (columnDef?.type) {
      case 'number':
        return formatNumber(value || 0)
      case 'percentage':
        return formatPercentage(value || 0)
      case 'time':
        return formatTime(value || 0)
      case 'currency':
        return formatCurrency(value || 0)
      case 'text':
      default:
        if (columnKey === 'consultantName') {
          return 'TOTAL'
        }
        if (columnKey === 'consultantType') {
          return 'ALL TYPES'
        }
        return value || 'N/A'
    }
  }

  // Render cell value based on column type
  const renderCellValue = (item, columnKey) => {
    const allColumns = getAllColumnsWithDynamic()
    const columnDef = allColumns[columnKey]
    const value = item[columnKey]
    
    // Handle dynamic columns
    if (columnDef?.isDynamic) {
      if (columnKey === 'consultantGender') {
        return item.consultantGender || 'N/A'
      }
      return columnDef.label.split(': ')[1] || 'N/A'
    }
    
    // Handle combined chat/call columns - now directly from API
    if (columnKey === 'totalAttemptChatCall') {
      return item.totalAttemptChatCall || 0
    }
    
    if (columnKey === 'totalFailedChatCall') {
      return item.totalFailedChatCall || 0
    }
    
    if (columnKey === 'totalCompletedChatCall') {
      return item.totalCompletedChatCall || 0
    }
    
    // Handle combined time columns
    if (columnKey === 'totalChatCallTime') {
      const totalTime = (item.totalFreeChatTime || 0) + (item.totalPaidChatTime || 0) + (item.totalFreeCallTime || 0) + (item.totalPaidCallTime || 0)
      return formatTime(totalTime)
    }
    
    if (columnKey === 'averageChatCallTime') {
      const totalTime = (item.totalFreeChatTime || 0) + (item.totalPaidChatTime || 0) + (item.totalFreeCallTime || 0) + (item.totalPaidCallTime || 0)
      const totalConsultations = (item.totalFreeChat || 0) + (item.totalPaidChat || 0) + (item.totalFreeCall || 0) + (item.totalPaidCall || 0)
      const avgTime = totalConsultations > 0 ? totalTime / totalConsultations : 0
      return formatTime(avgTime)
    }
    
    // Handle combined revenue columns
    if (columnKey === 'totalChatCallRevenue') {
      const totalRevenue = (item.totalChatRevenue || 0) + (item.totalCallRevenue || 0)
      return formatCurrency(totalRevenue)
    }
    
    if (columnKey === 'averageChatCallRevenue') {
      const totalRevenue = (item.totalChatRevenue || 0) + (item.totalCallRevenue || 0)
      const totalPaidConsultations = (item.totalPaidChat || 0) + (item.totalPaidCall || 0)
      const avgRevenue = totalPaidConsultations > 0 ? totalRevenue / totalPaidConsultations : 0
      return formatCurrency(avgRevenue)
    }
    
    // Handle chat-specific attempt columns
    if (columnKey === 'totalAttemptChat') {
      return item.totalAttemptChat || 0
    }
    
    if (columnKey === 'totalFailedChat') {
      const totalAttemptChat = item.totalAttemptChat || 0
      return totalAttemptChat - ((item.totalFreeChat || 0) + (item.totalPaidChat || 0))
    }
    
    if (columnKey === 'totalCompletedChat') {
      return (item.totalFreeChat || 0) + (item.totalPaidChat || 0)
    }
    
    // Handle call-specific attempt columns
    if (columnKey === 'totalAttemptCall') {
      return (item.totalAttemptCall || 0)
    }
    
    if (columnKey === 'totalFailedCall') {
      const totalAttemptCall = (item.totalAttemptCall || 0)
      return totalAttemptCall - ((item.totalFreeCall || 0) + (item.totalPaidCall || 0))
    }
    
    if (columnKey === 'totalCompletedCall') {
      return (item.totalFreeCall || 0) + (item.totalPaidCall || 0)
    }
    
    // Handle missing first-time paid time columns
    if (columnKey === 'totalFirstTimePaidChatTime') {
      const totalTime = item.totalFirstTimePaidChatTime || (item.averageFirstTimePaidChatTime * item.totalFirstTimeChat) || 0
      return formatTime(totalTime)
    }
    
    if (columnKey === 'averageFirstTimePaidChatTime') {
      return formatTime(item.averageFirstTimePaidChatTime || 0)
    }
    
    if (columnKey === 'totalFirstTimePaidCallTime') {
      const totalTime = item.totalFirstTimePaidCallTime || (item.averageFirstTimePaidCallTime * item.totalFirstTimeCall) || 0
      return formatTime(totalTime)
    }
    
    if (columnKey === 'averageFirstTimePaidCallTime') {
      return formatTime(item.averageFirstTimePaidCallTime || 0)
    }
    
    switch (columnDef?.type) {
      case 'number':
        return formatNumber(value || 0)
      case 'percentage':
        return formatPercentage(value || 0)
      case 'time':
        return formatTime(value || 0)
      case 'currency':
        return formatCurrency(value || 0)
      case 'text':
      default:
        if (columnKey === 'consultantType') {
          return Array.isArray(value) ? value.join(', ') : value || 'N/A'
        }
        return value || 'N/A'
    }
  }

  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="TitleBox">
          <div className="user_detail_heading">
            <Link className="back_icon" to={-2}>
              <IconButton>
                <ArrowBackIosNewIcon className="back_button" />
              </IconButton>
            </Link>
            <h4 className="Title">Consultant Insight Details</h4>
          </div>
        </div>
        {loader}
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
            

              {/* Search and Filter Bar */}
              <Box className="mb-4">
                <Typography variant="h6" className="mb-3">
                  Filters
                </Typography>
                 {/* Second Row - Consultant Type, Problem Type, and Gender Filters */}
                 <Grid container spacing={2} alignItems="center" className="mb-3">
                  <Grid item xs={12} md={2}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Consultant Type</InputLabel>
                      <Select
                        value={consultantType}
                        onChange={(e) => handleConsultantTypeChange(e.target.value)}
                        label="Consultant Type"
                      >
                        <MenuItem value="">
                          <em>All Consultant Types</em>
                        </MenuItem>
                        {consultantSkillOption.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Problem Type</InputLabel>
                      <Select
                        value={problemType}
                        onChange={(e) => handleProblemTypeChange(e.target.value)}
                        label="Problem Type"
                      >
                        <MenuItem value="">
                          <em>All Problem Types</em>
                        </MenuItem>
                        {expertiseOption.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Consultant Gender</InputLabel>
                      <Select
                        value={consultantGender}
                        onChange={(e) => handleConsultantGenderChange(e.target.value)}
                        label="Consultant Gender"
                      >
                        <MenuItem value="">
                          <em>All Genders</em>
                        </MenuItem>
                        {genderOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>User Gender</InputLabel>
                      <Select
                        value={userGender}
                        onChange={(e) => handleUserGenderChange(e.target.value)}
                        label="User Gender"
                      >
                        <MenuItem value="">
                          <em>All User Genders</em>
                        </MenuItem>
                        {genderOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="outlined"
                      onClick={clearFilters}
                      fullWidth
                      style={{ height: '56px' }}
                    >
                      Clear Filters
                    </Button>
                  </Grid>
                </Grid>
                {/* First Row - Search and Time Range */}
                <Grid container spacing={2} alignItems="center" className="mb-3">
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      placeholder="Search by consultant name, type, email, or phone..."
                      value={searchQuery}
                      onChange={handleSearch}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Time Range</InputLabel>
                      <Select
                        value={timeRange}
                        onChange={(e) => handleTimeRangeChange(e.target.value)}
                        label="Time Range"
                      >
                        <MenuItem value="">
                          <em>All Time Ranges</em>
                        </MenuItem>
                        {timeRangeOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {timeRange === 'custom' && (
                    <>
                      <Grid item xs={12} md={3}>
                        <TextField
                          fullWidth
                          type="date"
                          variant="outlined"
                          label="Start Date"
                          value={startDate}
                          onChange={(e) => handleDateChange('start', e.target.value)}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <TextField
                          fullWidth
                          type="date"
                          variant="outlined"
                          label="End Date"
                          value={endDate}
                          onChange={(e) => handleDateChange('end', e.target.value)}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>

            
                <Box className="mb-4">
                  {/* <Typography variant="h6" className="mb-3">
                    Consultant Insights Presentation
                  </Typography> */}
                  
                  <Grid container spacing={3}>
                  
                    {/* <Grid item xs={12} md={4}>
                      <Card 
                        elevation={2} 
                        sx={{ 
                          cursor: 'pointer',
                          border: insightType === 'all' ? '2px solid #1976d2' : '1px solid #e0e0e0',
                          bgcolor: insightType === 'all' ? '#f3f8ff' : 'white'
                        }}
                        onClick={() => handleInsightTypeChange('all')}
                      >
                        <CardContent>
                          <Typography variant="h6" color="primary" gutterBottom>
                            All Consultants Insight
                          </Typography>
                          <Typography variant="h4" fontWeight="bold" color="primary">
                            {insightsData?.pagination?.totalDocuments || 0}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            Total Consultants
                          </Typography>
                        
                        </CardContent>
                      </Card>
                    </Grid> */}

                
                    {/* <Grid item xs={12} md={4}>
                      <Card 
                        elevation={2} 
                        sx={{ 
                          cursor: 'pointer',
                          border: insightType === 'custom' ? '2px solid #1976d2' : '1px solid #e0e0e0',
                          bgcolor: insightType === 'custom' ? '#f3f8ff' : 'white'
                        }}
                        onClick={() => handleInsightTypeChange('custom')}
                      >
                        <CardContent>
                          <Typography variant="h6" color="primary" gutterBottom>
                            Custom Consultants Insight
                          </Typography>
                          <Typography variant="h4" fontWeight="bold" color="primary">
                            {getSelectedConsultantsCount()}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            Selected Consultants
                          </Typography>
                         
                        </CardContent>
                      </Card>
                    </Grid> */}

                  
                    {/* <Grid item xs={12} md={4}>
                      <Card 
                        elevation={2} 
                        sx={{ 
                          cursor: 'pointer',
                          border: insightType === 'single' ? '2px solid #1976d2' : '1px solid #e0e0e0',
                          bgcolor: insightType === 'single' ? '#f3f8ff' : 'white'
                        }}
                        onClick={() => handleInsightTypeChange('single')}
                      >
                        <CardContent>
                          <Typography variant="h6" color="primary" gutterBottom>
                            Single Consultant Insight
                          </Typography>
                          <Typography variant="h4" fontWeight="bold" color="primary">
                            {singleConsultant ? 1 : 0}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            Selected Consultant
                          </Typography>
                          
                        </CardContent>
                      </Card>
                    </Grid> */}
                  </Grid>

                  {/* <Grid container spacing={3} sx={{ mt: 2 }}>
                    <Grid item xs={12} md={3}>
                      <Paper elevation={1} sx={{ p: 2, textAlign: 'center' }}>
                        <Typography variant="h5" fontWeight="bold" color="success.main">
                          {insightsData?.totalFreeChatsCalls || 0}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Total Free Calls
                        </Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Paper elevation={1} sx={{ p: 2, textAlign: 'center' }}>
                        <Typography variant="h5" fontWeight="bold" color="warning.main">
                          {insightsData?.totalPaidChatsCalls || 0}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Total Paid Calls
                        </Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Paper elevation={1} sx={{ p: 2, textAlign: 'center' }}>
                        <Typography variant="h5" fontWeight="bold" color="info.main">
                          {formatCurrency(insightsData?.totalSpending || 0)}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Total Revenue
                        </Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Paper elevation={1} sx={{ p: 2, textAlign: 'center' }}>
                        <Typography variant="h5" fontWeight="bold" color="secondary.main">
                          {insightsData?.totalUniqueConsultants || 0}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Active Consultants
                        </Typography>
                      </Paper>
                    </Grid>
                  </Grid> */}

               
                  {insightType === 'custom' && (
                    <Box sx={{ mt: 3 }}>
                      <Typography variant="subtitle1" gutterBottom>
                        Select Consultants for Custom Analysis
                      </Typography>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel>Select Consultants</InputLabel>
                        <Select
                          multiple
                          value={selectedConsultants}
                          onChange={(e) => setSelectedConsultants(e.target.value)}
                          label="Select Consultants"
                          renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                              {selected.map((value) => {
                                const consultant = consultantList.find(c => c._id === value)
                                return (
                                  <Chip 
                                    key={value} 
                                    label={consultant?.name || value} 
                                    size="small"
                                    onDelete={() => handleConsultantSelection(value)}
                                  />
                                )
                              })}
                            </Box>
                          )}
                        >
                          {consultantList.map((consultant) => (
                            <MenuItem key={consultant._id} value={consultant._id}>
                              <Box>
                                <Typography variant="body2">
                                  {consultant.name}
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                  {consultant.type}
                                </Typography>
                              </Box>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  )}

                  {/* {insightType === 'single' && (
                    <Box sx={{ mt: 3 }}>
                      <Typography variant="subtitle1" gutterBottom>
                        Select Consultant for Individual Analysis
                      </Typography>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel>Select Consultant</InputLabel>
                        <Select
                          value={singleConsultant}
                          onChange={(e) => handleSingleConsultantChange(e.target.value)}
                          label="Select Consultant"
                        >
                          <MenuItem value="">
                            <em>Choose a consultant</em>
                          </MenuItem>
                          {consultantList.map((consultant) => (
                            <MenuItem key={consultant._id} value={consultant._id}>
                              <Box>
                                <Typography variant="body2">
                                  {consultant.name}
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                  {consultant.type}
                                </Typography>
                              </Box>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  )} */}
                                 </Box>
                 
               </Box>

               {/* Tab Navigation for Chat/Call Separation */}
               <Box className="mb-3">
                 <Tabs 
                   value={activeTab} 
                   onChange={(e, newValue) => setActiveTab(newValue)}
                   variant="fullWidth"
                   sx={{ 
                     borderBottom: 1, 
                     borderColor: 'divider',
                     backgroundColor: '#f8f9fa',
                     borderRadius: '8px 8px 0 0',
                     '& .MuiTab-root': {
                       minHeight: '48px',
                       textTransform: 'none',
                       fontWeight: 500,
                       '&.Mui-selected': {
                         backgroundColor: '#ffffff',
                         borderRadius: '8px 8px 0 0',
                         boxShadow: '0 -2px 4px rgba(0,0,0,0.1)'
                       },
                       '&:hover': {
                         backgroundColor: '#e9ecef',
                         borderRadius: '8px 8px 0 0'
                       }
                     },
                     '& .MuiTabs-indicator': {
                       backgroundColor: '#1976d2',
                       height: '3px'
                     }
                   }}
                 >
                   <Tab 
                     label={
                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                         <Typography variant="body1" sx={{ color: activeTab === 0 ? '#1976d2' : '#1976d2' }}>Combined View</Typography>
                         <Chip 
                           label="All" 
                           size="small" 
                           sx={{ 
                             backgroundColor: '#e3f2fd',
                             color: '#1976d2',
                             fontWeight: 500
                           }} 
                         />
                       </Box>
                     } 
                     icon={<ViewColumnIcon sx={{ color: activeTab === 0 ? '#1976d2' : '#1976d2' }} />}
                     iconPosition="start"
                   />
                   <Tab 
                     label={
                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                         <Typography variant="body1" sx={{ color: activeTab === 1 ? '#2e7d32' : '#2e7d32' }}>Chat Analytics</Typography>
                         <Chip 
                           label="Chat" 
                           size="small" 
                           sx={{ 
                             backgroundColor: '#e8f5e8',
                             color: '#2e7d32',
                             fontWeight: 500
                           }} 
                         />
                       </Box>
                     } 
                     icon={<ChatIcon sx={{ color: activeTab === 1 ? '#2e7d32' : '#2e7d32' }} />}
                     iconPosition="start"
                   />
                   <Tab 
                     label={
                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                         <Typography variant="body1" sx={{ color: activeTab === 2 ? '#f57c00' : '#f57c00' }}>Call Analytics</Typography>
                         <Chip 
                           label="Call" 
                           size="small" 
                           sx={{ 
                             backgroundColor: '#fff3e0',
                             color: '#f57c00',
                             fontWeight: 500
                           }} 
                         />
                       </Box>
                     } 
                     icon={<CallIcon sx={{ color: activeTab === 2 ? '#f57c00' : '#f57c00' }} />}
                     iconPosition="start"
                   />
                 </Tabs>
               </Box>

               {/* Section Headers */}
               <Box className="mb-3">
                 <Typography variant="h6" color="primary" gutterBottom>
                   {/* {activeTab === 0 && "COUNSULTANT INSIGHTS - Column Description"} */}
                   {activeTab === 1 && "CHAT ANALYTICS - Column Description"}
                   {activeTab === 2 && "CALL ANALYTICS - Column Description"}
                 </Typography>
                 
                 {/* {activeTab === 0 && (
                   <Box className="mb-2">
                     <Typography variant="subtitle1" fontWeight="bold" color="primary">
                       HEADING: NUMERICAL DATA - Summary of user activity shown in numbers.
                     </Typography>
                     <Typography variant="subtitle2" color="textSecondary" className="mb-2">
                       SUB HEADING: TOTAL (CHAT + CALL) - Combined total for all Chats and Calls, including both free and paid.
                     </Typography>
                   </Box>
                 )} */}
                 
                 {activeTab === 1 && (
                   <Box className="mb-2">
                     <Typography variant="subtitle1" fontWeight="bold" color="primary">
                       HEADING: CHAT COLUMN - Detailed chat consultation metrics.
                     </Typography>
                   </Box>
                 )}
                 
                 {activeTab === 2 && (
                   <Box className="mb-2">
                     <Typography variant="subtitle1" fontWeight="bold" color="primary">
                       HEADING: CALL COLUMN - Detailed call consultation metrics.
                     </Typography>
                   </Box>
                 )}
               </Box>

                              {/* Column Selector and Table Header */}
               <Box className="mb-3 d-flex justify-content-between align-items-center">
                 <Typography variant="h5">
                   {activeTab === 0 && "Combined Performance Insights"}
                   {activeTab === 1 && "Chat Performance Analytics"}
                   {activeTab === 2 && "Call Performance Analytics"}
                 </Typography>
                 <Box className="d-flex align-items-center gap-2">
                   <Chip 
                     label={`${getSelectedConsultantsCount()} consultants selected`}
                     color="secondary"
                     variant="outlined"
                     size="small"
                   />
                   <Chip 
                     label={`${Object.values(getColumnsGroupedByCategory()).flat().length} columns selected`}
                     color="primary"
                     variant="outlined"
                     size="small"
                   />
                   <Button
                     variant="outlined"
                     startIcon={<ViewColumnIcon />}
                     onClick={() => setColumnSelectorOpen(true)}
                   >
                     Customize Columns
                   </Button>
                 </Box>
               </Box>

              {/* Color Legend */}
              {/* <Box className="mb-3">
                <Typography variant="subtitle2" fontWeight="bold" className="mb-2">
                  Section Color Legend:
                </Typography>
                <Box className="d-flex flex-wrap gap-2">
                  <Chip 
                    label="Consultant Info" 
                    size="small" 
                    sx={{ backgroundColor: '#e3f2fd', border: '1px solid #1976d2' }}
                  />
                  <Chip 
                    label="Combined Metrics" 
                    size="small" 
                    sx={{ backgroundColor: '#f3e5f5', border: '1px solid #7b1fa2' }}
                  />
                  <Chip 
                    label="Chat Metrics" 
                    size="small" 
                    sx={{ backgroundColor: '#e8f5e8', border: '1px solid #388e3c' }}
                  />
                  <Chip 
                    label="Call Metrics" 
                    size="small" 
                    sx={{ backgroundColor: '#fff3e0', border: '1px solid #f57c00' }}
                  />
                  <Chip 
                    label="Time Metrics" 
                    size="small" 
                    sx={{ backgroundColor: '#e1f5fe', border: '1px solid #0277bd' }}
                  />
                  <Chip 
                    label="Revenue Metrics" 
                    size="small" 
                    sx={{ backgroundColor: '#e8eaf6', border: '1px solid #3f51b5' }}
                  />
                  <Chip 
                    label="Filter Applied" 
                    size="small" 
                    sx={{ backgroundColor: '#fff3e0', border: '1px solid #f57c00' }}
                  />
                </Box>
              </Box> */}

              {/* Consultant Insights Summary Table */}
              <Paper elevation={3} className="p-4">
                <div className="content-table" style={{ maxHeight: '600px', overflow: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead style={{ position: 'sticky', top: '0', zIndex: 2, backgroundColor: 'white' }}>
                      {/* Category Headers Row */}
                      <tr>
                                                <th style={{ 
                          backgroundColor: '#f5f5f5', 
                          border: '1px solid #e0e0e0', 
                          padding: '8px', 
                          fontWeight: 'bold',
                          textAlign: 'center',
                          fontSize: '12px',
                          borderRadius: '4px'
                        }}>
                          Selection
                        </th>
                        <th style={{ 
                          backgroundColor: '#f5f5f5', 
                          border: '1px solid #e0e0e0', 
                          padding: '8px', 
                          fontWeight: 'bold',
                          textAlign: 'center',
                          fontSize: '12px',
                          borderRadius: '4px'
                        }}>
                          S. No.
                        </th>
                        {Object.entries(getColumnsGroupedByCategory()).map(([category, columns]) => (
                          <th 
                            key={category}
                            colSpan={columns.length}
                            style={{
                              backgroundColor: getCategoryColor(category),
                              border: getCategoryBorderStyle(category),
                              padding: '12px 8px',
                              fontWeight: 'bold',
                              textAlign: 'center',
                              fontSize: '16px',
                              color: '#1976d2',
                              borderRadius: '4px'
                            }}
                          >
                            {category}
                          </th>
                        ))}
                      </tr>
                      
                      {/* Column Headers Row */}
                      <tr>
                        <th>
                          <Checkbox
                            checked={selectAllRows}
                            indeterminate={selectedTableRows.length > 0 && selectedTableRows.length < consultationList.length}
                            onChange={handleSelectAllTableRows}
                            size="small"
                          />
                        </th>
                        <th>S. No.</th>
                        {Object.entries(getColumnsGroupedByCategory()).map(([category, columns]) => 
                          columns.map((columnKey, columnIndex) => {
                            const allColumns = getAllColumnsWithDynamic()
                            const columnDef = allColumns[columnKey]
                            const isFirst = columnIndex === 0
                            const isLast = columnIndex === columns.length - 1
                            return (
                              <Tooltip 
                                key={columnKey}
                                title={getColumnInfo(columnKey)}
                                placement="top"
                                arrow
                              >
                                <th 
                                  style={{
                                    backgroundColor: getCategoryColor(columnDef.category),
                                    ...getColumnBorderStyle(columnDef.category, isFirst, isLast),
                                    padding: '12px 8px',
                                    fontWeight: '500',
                                    cursor: 'help',
                                    fontSize: '14px',
                                    borderRadius: isFirst || isLast ? '2px' : '0px',
                                    color: getCategoryBorderColor(columnDef.category)
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                    {columnDef.label}
                                    <InfoIcon sx={{ fontSize: 16, color: getCategoryBorderColor(columnDef.category), cursor: 'help' }} />
                                  </Box>
                                </th>
                              </Tooltip>
                            )
                          })
                        )}
                      </tr>
                    </thead>
                    {/* Fixed Totals Row */}
                    {consultationList.length > 0 && (
                      <thead style={{ 
                        position: 'sticky', 
                        top: '96px', 
                        zIndex: 1, 
                        backgroundColor: '#f5f5f5',
                        borderTop: '2px solid #333',
                        boxShadow: '0 -2px 4px rgba(0,0,0,0.1)'
                      }}>
                        <tr>
                          <th style={{ 
                            textAlign: 'center', 
                            fontWeight: 'bold',
                            backgroundColor: '#f5f5f5',
                            border: '1px solid #e0e0e0'
                          }}>TOTAL</th>
                          <th style={{ 
                            backgroundColor: '#f5f5f5', 
                            border: '1px solid #e0e0e0', 
                            padding: '12px 8px', 
                            fontWeight: 'bold',
                            textAlign: 'center'
                          }}>
                            -
                          </th>
                          {Object.entries(getColumnsGroupedByCategory()).map(([category, columns]) => 
                            columns.map((columnKey, columnIndex) => {
                              const allColumns = getAllColumnsWithDynamic()
                              const columnDef = allColumns[columnKey]
                              const totals = calculateTotals()
                              const isFirst = columnIndex === 0
                              const isLast = columnIndex === columns.length - 1
                              return (
                                <th 
                                  key={columnKey}
                                  style={{
                                    backgroundColor: getCategoryColor(columnDef.category),
                                    ...getColumnBorderStyle(columnDef.category, isFirst, isLast),
                                    padding: '12px 8px',
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    color: getCategoryBorderColor(columnDef.category),
                                    borderRadius: isFirst || isLast ? '2px' : '0px'
                                  }}
                                >
                                  {renderTotalsValue(totals, columnKey)}
                                </th>
                              )
                            })
                          )}
                        </tr>
                      </thead>
                    )}
                    <tbody>
                      {consultationList.length > 0 ? (
                        consultationList.map((item, index) => (
                          <tr key={item._id}>
                            <td style={{
                              border: '1px solid #e0e0e0',
                              backgroundColor: '#ffffff'
                            }}>
                              <Checkbox
                                checked={selectedTableRows.includes(item._id)}
                                onChange={() => handleTableRowSelection(item._id)}
                                size="small"
                              />
                            </td>
                            <td style={{
                              border: '1px solid #e0e0e0',
                              textAlign: 'center',
                              backgroundColor: '#ffffff'
                            }}>{findSerialNumber(index, activePage, pageSize)}</td>
                            {Object.entries(getColumnsGroupedByCategory()).map(([category, columns]) => 
                              columns.map((columnKey, columnIndex) => {
                                const allColumns = getAllColumnsWithDynamic()
                                const columnDef = allColumns[columnKey]
                                const isFirst = columnIndex === 0
                                const isLast = columnIndex === columns.length - 1
                                return (
                                  <td 
                                    key={columnKey} 
                                    style={{
                                      textAlign: 'center',
                                      backgroundColor: getDataRowColor(columnDef?.category),
                                      ...getColumnBorderStyle(columnDef?.category, isFirst, isLast),
                                      padding: '8px 4px',
                                      borderRadius: isFirst || isLast ? '2px' : '0px'
                                    }}
                                  >
                                    {renderCellValue(item, columnKey)}
                                  </td>
                                )
                              })
                            )}
                          </tr>
                        ))
                      ) : (
                        <NotFound
                          cols={Object.values(getColumnsGroupedByCategory()).flat().length + 2}
                          msg="No consultant data found!"
                          loader={loader}
                        />
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination and Page Size Controls */}
                <div className="pagination-wrapper mt-4 d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center gap-3">
                    <Typography variant="body2" color="textSecondary">
                      Show:
                    </Typography>
                    <FormControl size="small" sx={{ minWidth: 80 }}>
                      <Select
                        value={pageSize}
                        onChange={(e) => handlePageSizeChange(e.target.value)}
                        displayEmpty
                      >
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={25}>25</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                    <Typography variant="body2" color="textSecondary">
                      consultants per page
                    </Typography>
                  </div>
                  
                  <div className="d-flex align-items-center gap-2">
                    <Typography variant="body2" color="textSecondary">
                      Showing {((activePage - 1) * pageSize) + 1} to {Math.min(activePage * pageSize, total)} of {total} consultants
                    </Typography>
                  </div>
                  
                  {total > pageSize && (
                    <div className="Pagination">
                      <Pagination
                        activePage={activePage}
                        itemsCountPerPage={pageSize}
                        totalItemsCount={total}
                        pageRangeDisplayed={5}
                        onChange={handlePageChange}
                        itemClass="page-item"
                        linkClass="page-link"
                      />
                    </div>
                  )}
                </div>
              </Paper>

              {/* Column Selector Drawer */}
              <Drawer
                anchor="right"
                open={columnSelectorOpen}
                onClose={() => setColumnSelectorOpen(false)}
                PaperProps={{
                  sx: { width: 400 }
                }}
              >
                <Box sx={{ p: 3 }}>
                  <Typography variant="h6" className="mb-3">
                    Customize Columns
                  </Typography>
                  
                  {/* Global Actions */}
                  <Box className="mb-3">
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handleSelectAllColumns}
                      className="me-2"
                    >
                      Select All
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handleDeselectAllColumns}
                    >
                      Deselect All
                    </Button>
                  </Box>

                  <Divider className="mb-3" />

                  {/* Column Categories */}
                  {Object.entries(getAllColumnsByCategory()).map(([category, columns]) => (
                    <Box 
                      key={category} 
                      className="mb-4"
                      sx={{
                        backgroundColor: getCategoryColor(category),
                        borderRadius: 1,
                        p: 2,
                        border: '1px solid #e0e0e0'
                      }}
                    >
                      <Box className="d-flex justify-content-between align-items-center mb-2">
                        <Typography variant="subtitle1" fontWeight="bold" color="primary">
                          {category}
                        </Typography>
                        <Box>
                          <Button
                            size="small"
                            onClick={() => handleSelectAllInCategory(category)}
                            className="me-1"
                          >
                            All
                          </Button>
                          <Button
                            size="small"
                            onClick={() => handleDeselectAllInCategory(category)}
                          >
                            None
                          </Button>
                        </Box>
                      </Box>
                      
                      <List dense>
                        {columns.map((column) => (
                          <ListItem key={column.key} dense>
                            <ListItemIcon>
                              <Checkbox
                                edge="start"
                                checked={visibleColumns[column.key]}
                                onChange={() => handleColumnToggle(column.key)}
                                size="small"
                              />
                            </ListItemIcon>
                            <ListItemText 
                              primary={column.label}
                              secondary={column.type}
                            />
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                  ))}

                  <Divider className="mb-3" />
                  
                                     <Box className="d-flex justify-content-between">
                     <Typography variant="body2" color="textSecondary">
                       {Object.values(getColumnsGroupedByCategory()).flat().length} of {Object.keys(getAllColumnsWithDynamic()).length} columns selected
                     </Typography>
                     <Button
                       variant="contained"
                       onClick={() => setColumnSelectorOpen(false)}
                     >
                       Apply
                     </Button>
                   </Box>
                </Box>
              </Drawer>

            
               
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConsultantInsight